import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RoutingParamService {

  constructor() { }

  private routeParamSource = new BehaviorSubject<any>(null);
  routingParams = this.routeParamSource.asObservable();

  setRoutingParam(param: any) {
    this.routeParamSource.next(param);
  }
}
